import React, { useState } from 'react';
import { Box, Button } from '@material-ui/core';
import style from '../social-network/social-network.module.scss';
import AddIcon from '@material-ui/icons/Add';
import { AddVideoDialog } from './add-video-dialog';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { GetUrlBuilderData } from 'store/url-builder';
import { GetConfigData } from 'store/config/selectors';
import { getVideoUrl } from 'utils/pathBuilder';

export interface VideoUploadProps{
    builderType: string;
}

export const VideoUpload = ({builderType}:VideoUploadProps) => {
 const [openDialog, setOpenDialog] = useState(false);
 const builderData = useSelector(GetUrlBuilderData);
 const confData = useSelector(GetConfigData);
 const videoUrl = getVideoUrl(builderData.video, confData);

 return (
  <>
   <Box sx={{ position: 'relative', minHeight: '20em', minWidth: '100%' }}>
    {videoUrl && <ReactPlayer url={videoUrl} controls width='100%' />}
    <Button onClick={() => setOpenDialog(true)} className={`${style.videoButton} ${style.videoButtonHover}`}>
     <AddIcon /> Video
    </Button>
   </Box>
   {openDialog && <AddVideoDialog open={openDialog} onClose={() => setOpenDialog(false)} builderType={builderType}/>}
  </>
 );
};
